import e from './style.module.css';
import Form from 'react-bootstrap/Form';


type SearchType ={ 
  className?: string,
  label: string,
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
  placeholder?: string,
  disabled?: boolean,
  labelClass?: string
}

export default function Search ({ onChange, label, className, placeholder, disabled, labelClass}:SearchType ) {
  return (
    <div className={className}>
        <label className={`bold ${labelClass}`} >{label}:</label>
        <Form.Control type='text' disabled={disabled} placeholder={placeholder || label} className={e.search_input} 
        onChange={onChange}/>
    </div>
  )
}
